export default __webpack_public_path__ + "static/media/pantry1-afterI-1440w.b223b613.avif";